import { Typography } from "@king-ict/eupisi-ui/components";

interface IProps {
  value?: string | null;
  maxLength: number;
  className?: string;
}

export const CharacterCounter = ({ value, maxLength, className }: IProps) => {
  const currentLength = (value || "").length;

  return (
    <Typography variant="small" color="light" className={className}>
      {`${currentLength} / ${maxLength}`}
    </Typography>
  );
};
